module.exports = __webpack_public_path__ + "static/newton-3afb51d27b4fdaf056a8f2d6be00603a.jpeg";